import { render, staticRenderFns } from "./cols.vue?vue&type=template&id=056fb5ce&scoped=true&lang=pug&"
import script from "./cols.vue?vue&type=script&lang=js&"
export * from "./cols.vue?vue&type=script&lang=js&"
import style0 from "./cols.vue?vue&type=style&index=0&id=056fb5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fb5ce",
  null
  
)

export default component.exports